import React from "react";

const PurchaseTransactions = (props) => {
    return (
        <table className="table table-striped mt-5">
            <thead>
                <tr>
                    <th>Order ID</th>
                    <th>User</th>
                    <th>Product ID</th>
                    <th>Source</th>
                    <th>Status</th>
                    <th>Purchase Date</th>
                </tr>
            </thead>
            <tbody>
                {props.data?.length > 0 ? (
                    props.data.map((data, index) => {
                        return (
                            <tr key={index}>
                                <td>{data.orderId || "-"}</td>
                                <td>{data.userId?.username || data.userId?.name || data.userId?.email || "Deleted user"}</td>
                                <td className="text-primary">{data.productId}</td>
                                <td className="text-info">{data.source?.replaceAll("_", " ")}</td>
                                <td className="text-success">{data.status}</td>
                                <td>{new Date(data.createdAt).toLocaleString()}</td>
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan="7" align="center">
                            Nothing to show!!
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default PurchaseTransactions;
